import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight, ArrowDownWideNarrow } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEvaluation } from "./EvaluatorApp";
import { EvaluatorHeader, JobButton } from "./EvaluatorHeader";
import { CandidateBoard } from "./CandidateBoard";

export default function RankingPage() {
  const { ctx, token, saveRanking } = useEvaluation();
  const nav = useNavigate();
  const allDone = ctx.progress.evaluated === ctx.progress.total;
  const sortedByOverall = () => [...ctx.candidates].sort((a, b) => (ctx.evaluations[b.id]?.overall_score ?? -1) - (ctx.evaluations[a.id]?.overall_score ?? -1)).map((c) => c.id);
  const applyOverallOrder = () => saveRanking(sortedByOverall()).catch(() => {});
  useEffect(() => { if (!ctx.ranking_touched) applyOverallOrder(); }, [ctx.ranking_touched]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="min-h-screen">
      <EvaluatorHeader right={<JobButton />} />
      <main className="fade-up mx-auto max-w-3xl px-4 py-10 sm:px-6">
        <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="eyebrow mb-2">Sıralama</p>
            <h1 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl">Adayları Sırala</h1>
            <p className="mt-2 max-w-xl text-sm text-plena-text2" data-testid="ranking-instruction">Liste, verdiğiniz genel uygunluk puanlarına göre hazır geldi. Bu pozisyon için nihai kararınızı yansıtacak şekilde kartları sürükleyerek veya ok tuşlarıyla yeniden sıralayabilirsiniz.</p>
          </div>
          <Button variant="outline" size="sm" data-testid="sort-by-overall-button" onClick={applyOverallOrder} className="shrink-0 rounded-full"><ArrowDownWideNarrow className="mr-1.5 h-3.5 w-3.5" /> Genel puana göre sırala</Button>
        </div>
        {!allDone && <p className="mb-6 rounded-xl bg-[#FDF4DC] px-5 py-3 text-sm text-[#8A6414]" data-testid="ranking-incomplete-warning">{ctx.progress.total - ctx.progress.evaluated} adayın kriter değerlendirmesi henüz tamamlanmadı.</p>}
        <CandidateBoard sortable />
        <div className="mt-10 flex items-center justify-between">
          <Button variant="ghost" data-testid="ranking-back" onClick={() => nav(`/e/${token}/candidates`)} className="rounded-full"><ArrowLeft className="mr-1.5 h-4 w-4" /> Adaylara dön</Button>
          <Button data-testid="ranking-continue" onClick={() => nav(`/e/${token}/review`)} className="btn-press rounded-full">Sıralamayı Onayla <ArrowRight className="ml-1.5 h-4 w-4" /></Button>
        </div>
      </main>
    </div>
  );
}
